module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/timer-22cbf34075a13b4a3f12bbea26ba8cfe.png";